<script setup>
// Google Ads > Donusumler

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import GoogleAdsKabuk from './GoogleAdsKabuk.vue';
import GoogleAdsTablo from './GoogleAdsTablo.vue';
import { getir, hataMetni } from './kopru.js';

const { t } = useI18n();
const route = useRoute();

const satirlar = ref([]);
const paraBirimi = ref('');
const yukleniyor = ref(false);
const hata = ref('');

const SUTUNLAR = [
  { alan: 'ad', anahtar: 'GOOGLE_ADS.SUTUN.AD', siralanabilir: true, vurgu: true },
  { alan: 'kategori', anahtar: 'GOOGLE_ADS.SUTUN.KATEGORI', tur: 'etiket', siralanabilir: true },
  { alan: 'durum', anahtar: 'GOOGLE_ADS.SUTUN.DURUM', tur: 'durum', siralanabilir: true },
  { alan: 'sayim', anahtar: 'GOOGLE_ADS.SUTUN.SAYIM', tur: 'etiket', siralanabilir: true },
  { alan: 'adet', anahtar: 'GOOGLE_ADS.SUTUN.ADET', tur: 'sayi', siralanabilir: true },
  { alan: 'deger', anahtar: 'GOOGLE_ADS.SUTUN.DEGER', tur: 'para', siralanabilir: true },
];

const yukle = async aralik => {
  yukleniyor.value = true;
  hata.value = '';
  try {
    const veri = await getir(route.params.accountId, 'donusumler', { aralik });
    satirlar.value = veri.donusumler || [];
    paraBirimi.value = veri.para_birimi || '';
  } catch (e) {
    satirlar.value = [];
    hata.value = hataMetni(e, t('GOOGLE_ADS.HATA'));
  } finally {
    yukleniyor.value = false;
  }
};
</script>

<template>
  <GoogleAdsKabuk
    :baslik="t('GOOGLE_ADS.DONUSUMLER')"
    :aralik-goster="true"
    @aralik="yukle"
  >
    <div class="flex flex-col gap-3">
      <p v-if="hata" class="text-sm text-n-ruby-11">{{ hata }}</p>
      <div v-if="yukleniyor" class="flex justify-center p-10">
        <Spinner class="text-n-brand" />
      </div>
      <GoogleAdsTablo
        v-else
        :sutunlar="SUTUNLAR"
        :satirlar="satirlar"
        :para-birimi="paraBirimi"
        varsayilan-siralama="adet"
      />
    </div>
  </GoogleAdsKabuk>
</template>
